import React, { useEffect, useMemo, useState } from 'react';
import { get } from 'lodash';
import {
  dashboardsSelector,
  tempKeysSelector,
  afterInitializationSelector,
} from '@store/tempDashboard/selectors';
import { useDispatch, useSelector } from 'react-redux';
import { PageNotFound } from '@components/common';
import * as tempDashboardActions from '@store/tempDashboard/actions';
import { useParams } from 'react-router-dom';

// TODO: also support updating LS based on state changes
function TempDashboardHoc({ applyCallback, initStore, children }) {
  const dispatch = useDispatch();
  const localStorageInit = useSelector(afterInitializationSelector);
  const [ready, setReady] = useState(false);
  const dashboards = useSelector(dashboardsSelector);
  const dashboardKeys = useSelector(tempKeysSelector);
  const { id:tempDashboardId = -1 } = useParams();

  // load temp dashboard data from LS
  useEffect(() => {
    if (!localStorageInit) {
      dispatch(tempDashboardActions.init());
    }
  }, [dispatch, localStorageInit]);

  // selected dashboard config
  const dashboardConfig = useMemo(() => {
    return dashboards[tempDashboardId];
  }, [dashboards, tempDashboardId]);

  // saga actions
  useEffect(() => {
    if (dashboardConfig) {
      applyCallback(dashboardConfig, () => {

        // update last accessed time
        dispatch(tempDashboardActions.updateAccessedTime(tempDashboardId));

        // init complete
        setReady(true);
      });

    }
  }, [applyCallback, get(dashboardConfig, 'dashboard', tempDashboardId)]);


  // intialize jotai store with default state
  const store = useMemo(() => {
    if (dashboardConfig) {
      return initStore(dashboardConfig);
    }
    return null;
  }, [dashboardConfig, initStore]);

  if (!dashboardKeys.includes(tempDashboardId)) {
    return <PageNotFound />;
  }

  return ready ? children({ store, title: dashboardConfig.title  }) : <>Loading...</>;
}

export default TempDashboardHoc;
